(function () {
    'use strict';

    angular
        .module('salesflare.components.slippingDeals', [])
        .component('sfSlippingDeals', {
            templateUrl: 'app-ajs/components/dashboards/predefinedReports/slippingDeals/slippingDeals.html',
            controller,
            controllerAs: 'vm',
            bindings: {
                data: '<'
            }
        });

    function controller($state, $mdMedia, model, config) {

        const vm = this;

        vm.model = model;

        ////////////////

        vm.$onChanges = function (changes) {

            if (!changes || !changes.data || !changes.data.currentValue) {
                return;
            }

            if (vm.data.deals.length === 0) {
                vm.data = {
                    no_data: true,
                    id: vm.data.id,
                    deals: [
                        { opportunity: 'Demo for Google', account: 'Google', account_logo: 'https://d2ojpxxtu63wzl.cloudfront.net/static/b560062037213e5dd697ef328cecdd3c_9c5671e1cd34db87e3d8bbfb230555c37b4572c9769d40c5eb04b6233b0e2a57', last_interaction_date: new Date().setDate(new Date().getDate() - 5) },
                        { opportunity: 'Demo for Facebook', account: 'Facebook', account_logo: config.logoApi + 'e3ef2bf121699043dbe2466d56576aba--8719d1461f33832036b0ee2b4464b99f', last_interaction_date: new Date().setDate(new Date().getDate() - 7) },
                        { opportunity: 'Demo for Youtube', account: 'Youtube', account_logo: 'https://d2ojpxxtu63wzl.cloudfront.net/static/68bdc551de55a3b98e469a567ea4d073_80ce7ef516349893a46c3137e287c3bbc01382b4048c3a26bb56e0cc41d8d2ba', last_interaction_date: new Date().setDate(new Date().getDate() - 13) }
                    ]
                };
            }
        };

        vm.goToAccount = function (accountId, accountName) {

            if ($mdMedia('gt-sm')) {
                return $state.go('accounts.account.feed', { id: accountId, name: accountName });
            }
            else {
                return $state.go('accounts.account.info', { id: accountId, name: accountName });
            }
        };
    }
})();
